let API_URL = process.env.REACT_APP_SERVER_URL;
console.log (API_URL)
//named export
export { API_URL };